import { Component,  Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { AVLSummary } from '@features/live-tracking/models/avl-summary.model';
import { ShipmentAPI } from '../../../shipments/services/shipment-api.service';

@Component({
  selector: 'app-avl-summary',
  templateUrl: './avl-summary.component.html',
  styleUrls: ['./avl-summary.component.scss'],
})
export class AvlSummaryComponent extends BaseComponent implements OnChanges {
  @Input() shipmentId: number;
  @Input() summary: AVLSummary;
  avlSummary: AVLSummary;

  constructor(private shipmentsApiService: ShipmentAPI, ) {
    super();
  }

  ngOnChanges({ shipmentId, summary }: SimpleChanges): void {
    if (shipmentId && shipmentId.currentValue !== shipmentId.previousValue) {
      this.getSummary();
    }

    if (summary && summary.currentValue !== summary.previousValue) {
      this.avlSummary = this.summary;
    }
  }

  getSummary(): void {
    this.load(this.shipmentsApiService.getAVLsummary(this.shipmentId)).subscribe((summary) => {
      this.avlSummary = summary;
    });
  }
}
